import React from "react";

export default function BucketsTableDuration(props) {
  let { data } = props;

  return (
    <>
      {(data.length === 0) ? "<tr><td colSpan={2}>No data found</td></tr>" : data.map((x, index) => {
        return (<tr key={index}>
          <td scope="row">{x.key.vehicleId}</td>
          <td >{(x.SC20_100TimeInMin.values["50.0"]).toFixed(2)} </td>
        </tr>)
      })}
    </>
  );
}